import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../app.constant';


@Injectable({
  providedIn: 'root'
})
export class PaymentdetailsService {
 
  private host = environment.apiHost;
  private baseUrl1 =`${this.host}/getadcustdetails`;
  private baseUrl =`${this.host}/paymentdetails`;
 
  constructor(private http: HttpClient) { }

  paymentdetails(createddate): Observable<any> {
    return this.http.get(`${this.baseUrl}/${createddate}`);

  }
  getadcustdetails(orderid):Observable<any>{
    return this.http.get(`${this.baseUrl1}/${orderid}`);
  }
 
}
